import React from "react";
import {useStores} from "../../../../../Hooks";
import countries from 'world-countries';
import {observer} from "mobx-react";

export const WorkspaceOptionsPicker = observer(({settings}) => {
    const {modalStore, generalStore, workspaceManagementStore} = useStores();
    const settingsActions = {
        'Country': {
            searchPlaceHolder: 'Search for a country',
            Icon: null,
            handleSelect: (item) => {
                workspaceManagementStore.editedDomain = {...workspaceManagementStore.editedDomain, Country: item.label}
                modalStore.isGenericSelectSearchModalOpen= false;
            },
            handleNoResult: null,
            noResultText: '',
            list:  countries.filter(c => c.unMember).map(c => ({
                label: c.name.common,
                value: c.name.common
                })).sort((a, b) => a.label.localeCompare(b.label))
        },

    }

    const handleOpenSelectModal = (e,settingsType)=>{
        const rect = e.currentTarget.getBoundingClientRect();
        const x = rect.right -224;
        const y = rect.bottom + 10

        const settingsAction = settingsActions[settingsType] ?? settings.settingsAction ?? null;
        if (!settingsAction) return;
        modalStore.modalData.genericSelectData=
            {
                ...modalStore.modalData,
                position: {x: x, y: y},
                ...settingsAction,
            }
        modalStore.isGenericSelectSearchModalOpen = true

    }
    return (
        <div onClick={(e)=>{handleOpenSelectModal(e, settings.fieldInDb)}} data-testid={`sub-ws-picker-${settings.fieldInDb}`} className="flex flex-row justify-between items-center w-full">
            <div className="truncate overflow-hidden whitespace-nowrap">{settings.formattedValue ?? settings.value ?? settings.placeholder}</div>
            {settings.Icon}
        </div>
    )
})